import axios from '../../config/axios';
import getEnv from '../getEnv';

const context = getEnv('painel');

export default {
  validateCard: async payload => {
    const { lastDigits } = payload;
    let data;
    try {
      const response = await axios.get(
        `${context}/cards/validate/${lastDigits}`,
      );

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  provisionalCard: async payload => {
    const { cardNumber } = payload;
    let data;
    try {
      const response = await axios.get(
        `${context}/cards/findprovisionalcard/${cardNumber}`,
      );

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  createCardPassword: async payload => {
    const { encryptedData, ipAddress, origin, requester } = payload;
    let data;
    try {
      const response = await axios.post(
        `${context}/cards/v2/createpasswordcard/`,
        {
          encryptedData,
          ipAddress,
          origin,
          requester,
        },
      );

      data = response?.data;
    } catch (e) {
      const errorMessages = {
        messages: e.response?.data?.messages,
        result: e.response?.data?.result,
      };
      throw errorMessages;
    }

    return data;
  },
  getPublicKey: async () => {
    let data;
    try {
      const response = await axios.post(
        `${context}/cards/v2/publickeycreatepasswordcard/`,
      );

      data = response?.data?.result;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  changeCardPassword: async payload => {
    const {
      confirmationNewPassword,
      cpf,
      currentPassword,
      newPassword,
      numberCard,
    } = payload;
    let data;
    try {
      const response = await axios.put(`${context}/cards/changepasswordcard`, {
        confirmationNewPassword,
        cpf,
        currentPassword,
        newPassword,
        numberCard,
      });

      data = response?.data;
    } catch (e) {
      const errorMessages = {
        messages: e.response?.data?.messages,
        result: e.response?.data?.result,
      };

      throw errorMessages;
    }

    return data;
  },
  getCards: async () => {
    // const response = await axios.get(`${context}/cards/v2/${cpf}`);
    const response = await axios.get(`${context}/cards/v2/`);

    // Remoção dos cartões com codigoProduto 242 (cartões adicionais).
    // Futuramente deverão ser permitidos pois teremos cartões virtuais no portal, que segundo
    // as definições atuais, serão de ID 242 (PBN-458)
    return response?.data?.result?.filter(card => card.codigoProduto !== 242);
  },
  transactions: async (
    cpf,
    tokenCard,
    numberAccount,
    days,
    page,
    itemsPerPage,
  ) => {
    const response = await axios.get(
      `${getEnv(
        'extrato',
      )}/extract/v2/transactionsbydays/${tokenCard}/${numberAccount}/${days}/${page}/${itemsPerPage}`,
    );

    return response?.data;
  },
  provisionalTransactions: async (cardNumber, page, itemsPerPage) => {
    const response = await axios.get(
      `${getEnv(
        'extrato',
      )}/extract/transactionsprovisionalcard/${cardNumber}/${page}/${itemsPerPage}`,
    );

    return response?.data;
  },
  lockReasons: async () => {
    let data;
    try {
      const response = await axios.get(`${context}/cards/gettypelockcard`);

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  lockCard: async payload => {
    const { code, cnpjRH, comments = '', numberCard } = payload;
    let data;
    try {
      const response = await axios.patch(`${context}/cards/lockcard`, {
        blockReasonCode: code,
        cnpjRH,
        comments,
        numberCard,
      });

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
  unlockCard: async payload => {
    const { birthDate, numberCard } = payload;

    let data;
    try {
      const response = await axios.patch(
        `${context}/cards/cardreleasenominal`,
        {
          birthDate,
          numberCard,
        },
      );

      data = response?.data;
    } catch (e) {
      const errorMessages = {
        messages: e.response?.data?.messages,
        result: e.response?.data?.result,
      };

      throw errorMessages;
    }

    return data;
  },
  getSVA: async () => {
    let data;
    try {
      const response = await axios.get(`${context}/cards/findcardsva/`);

      data = response?.data;
    } catch (e) {
      const errorMessages = { messages: e.response?.data?.messages };
      throw errorMessages;
    }

    return data;
  },
};
